import { Component, OnInit, Injector }  from '@angular/core';
import ObjectList from 'src/app/models/ObjectList';
import ZimbraInstance from 'src/app/models/ZimbraInstance';
import ZimbraInstanceSearch from 'src/app/models/ZimbraInstanceSearch';
import { ZimbraInstanceService } from 'src/app/_service/zimbrainstance.service';
import ZimbraUser                             from '../../models/ZimbraUser';
import UserSearch                       from '../../models/UserSearch';
import { AdminOnlyPageComponent }       from '../../_components/AdminOnlyPageComponent';
import { UtilityService } from 'src/app/_service/utility.service';

@Component({
  selector: 'app-user-create-edit',
  templateUrl: './user-create-edit.component.html',
  styleUrls: ['./user-create-edit.component.css']
})
export class UserCreateEditComponent extends AdminOnlyPageComponent implements OnInit {

  user            : ZimbraUser        = new ZimbraUser();
  user_search     : UserSearch  = new UserSearch();

  zimbrainstance_search       : ZimbraInstanceSearch        = new ZimbraInstanceSearch();
  zimbrainstances             : ObjectList<ZimbraInstance>  = new ObjectList();

  constructor(
    injector                    : Injector,
    private _zimbraInstanceService : ZimbraInstanceService
  )
  {
    super(injector);
  }

  ngOnInit() 
  {
    this._getZimbraInstances();
    this.getUser();
  }

  getUser()
  {
    //If im editing a ZmInstance, an ID is passed from URL
    const id = +this._route.snapshot.paramMap.get('id');
    if (id > 0)
    {
      // this.in_update = true;
      this.user_search.id = id;
      this._userService.getUsers(this.user_search)
        .subscribe(data => {
          this.user        = new ZimbraUser(data["retdata"]["data"][0]);
        },
        err => {
            this._interfaceService.openSimpleErrorSnackBar(err);
        });
    }
  }

  _getZimbraInstances()
  {
    this._zimbraInstanceService.getZimbraInstances(this.zimbrainstance_search).subscribe(
      data => {
           
        this.total_rows         = data["retdata"]["total"];
        this.zimbrainstances.clear();
        for (var current of data["retdata"]["data"])
        {
          this.zimbrainstances.push(new ZimbraInstance(current) , "id");
        }
        
      },
      err => {
        this._interfaceService.openSimpleErrorSnackBar(this._translateService.instant("errors.something_went_wrong"));
    })
  }

  save()
  {
      if (UtilityService.empty(this.user.first_name) || UtilityService.empty(this.user.last_name))
      {
          this.user.first_name = "--";
          this.user.last_name = "--";
      }
   
      if (this.user.id !== null && this.user.id !== undefined)
      {
        this._userService.updateUser(this.user).subscribe(
          data => {
            var res                 = data["retdata"]["data"];
            this._interfaceService.openSimpleInfoSnackBar(this._translateService.instant(res));
            this._router.navigate(['/dashboard/admin/users']);
          },
          err => {
            this._interfaceService.openSimpleErrorSnackBar(this._translateService.instant("errors.something_went_wrong"));
        });
      }
      else
      {
        this._userService.createUser(this.user).subscribe(
          data => {
            var res                 = data["retdata"]["data"];
            this._interfaceService.openSimpleInfoSnackBar(this._translateService.instant(res));
            this._router.navigate(['/dashboard/admin/users']);
          },
          err => {
            this._interfaceService.openSimpleErrorSnackBar(this._translateService.instant("errors.something_went_wrong"));
        });
      }

    
    
  }

}
